export default {
  'menu.dashboard.workplace': 'Workplace',
  'workplace.welcome': 'Welcome!',
  'workplace.balance': 'Balance (CNY)',
  'workplace.order.pending': 'Pending',
  'workplace.order.pendingRenewal': 'Renewal Order',
  'workplace.onlineContent': 'Online Content',
  'workplace.putIn': 'Put In',
  'workplace.newDay': 'Daily Additional Comments',
  'workplace.newFromYesterday': 'New From Yesterday',
  'workplace.minute': 'Min',
  'workplace.docs': 'Documents',
  'workplace.docs.productOverview': 'Product Overview',
  'workplace.docs.userGuide': 'User Guide',
  'workplace.docs.workflow': 'Workflow',
  'workplace.docs.interfaceDocs': 'Interface Docs',
  //
  'workplace.contentManagement': 'Content Management',
  'workplace.contentStatistical': 'Content Statistical',
  'workplace.advanced': 'Advanced',
  'workplace.onlinePromotion': 'Online Promotion',
  'workplace.contentPutIn': 'Put In',
  'workplace.announcement': 'Announcement',
  'workplace.recently.visited': 'Recently Visited',
  'workplace.record.nodata': 'No data',
  'workplace.quick.operation': 'Quick Operation',
  'workplace.quickOperation.setup': 'Setup',
  'workplace.allProject': 'All',
  'workplace.loadMore': 'More',
  'workplace.viewMore': 'More',
  'workplace.contentData': 'Content Data',
  'workplace.popularContent': 'Popular Content',
  'workplace.popularContent.text': 'text',
  'workplace.popularContent.image': 'image',
  'workplace.popularContent.video': 'video',
  'workplace.categoriesPercent': 'Categories Percent',
  'workplace.pecs': 'pecs',
};
